import { JSON_STRING, MHTTPCL } from "./http/http-client";
import { EXT_REQUEST } from "./common-urls";
import { HttpLib } from "./http/http-lib";

export const QuestionnaireService = {
  getData: (checksum, promoter_id, calendar_date_id, lang) =>
    HttpLib.get(
      `${MHTTPCL.baseUrl}/promoter/${MHTTPCL.clientName
      }/${checksum}/${promoter_id}/calendar_date_id=${calendar_date_id}&lang=${lang}&output=${JSON_STRING}&viewtype=original`
    ),
  get_flyer_files: (checksum, promoter_id, calendar_date_id, lang) =>
    HttpLib.get(
      `${MHTTPCL.baseUrl}/promoter/${MHTTPCL.clientName
      }/${checksum}/${promoter_id}/calendar_date_id=${calendar_date_id}&lang=${lang}&viewtype=original&action=get_flyer_files`
    ),
  findHotelList: (checksum, promoter_id, calendar_date_id, lang, term, searchTypeParam = undefined) => {
    return HttpLib.get(
      `${MHTTPCL.baseUrl}/promoter/${MHTTPCL.clientName
      }/${checksum}/${promoter_id}/calendar_date_id=${calendar_date_id}&lang=${lang}&output=${JSON_STRING}&viewtype=original`,
      {
        params: {
          action: "get_google_places_api_hotel_list",
          searchTypeParam,
          term,
        }
      }
    );
  },
  getHotelDetails: (
    checksum,
    promoter_id,
    calendar_date_id,
    lang,
    place_id
  ) => {
    return HttpLib.get(
      `${MHTTPCL.baseUrl}/promoter/${MHTTPCL.clientName
      }/${checksum}/${promoter_id}/calendar_date_id=${calendar_date_id}&lang=${lang}&output=${JSON_STRING}&viewtype=original`,
      {
        params: {
          action: "get_google_places_api_hotel_details",
          place_id
        }
      }
    );
  }
};

// findLocation: term => {
//   return HttpLib.get(
//     `${MHTTPCL.baseUrl}/request/${MHTTPCL.clientName}/ext_request.pl`,
//     {
//       params: {
//         action: "get_location",
//         term
//       }
//     }
//   );
// }
